<div [class.selected]="isFocused" class="content" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon>
    <ng-content></ng-content>
  </mat-icon>
</div>
